"use strict";

/**
 * ======================================
 * ======= 品牌代言人
 * ======================================
 */

VogComponent((_) => {
  /**
   * @typedef {Object} Region
   * @property {string} country 国家
   * @property {number} x 横坐标 (button 响应式位置)
   * @property {number} y 纵坐标 (button 响应式位置)
   * @property {number} designX 设计稿原始横坐标 (SVG 圆点使用)
   * @property {number} designY 设计稿原始纵坐标 (SVG 圆点使用)
   * @property {number} originalX 参考横坐标 (用于 resize 计算)
   * @property {number} originalY 参考纵坐标 (用于 resize 计算)
   *
   * @typedef {Object} Product
   * @property {string} image 图片 URL
   * @property {string} description 描述
   *
   * @typedef {Object} User
   * @property {number} id
   * @property {string} name 姓名
   * @property {string} avatarUrl 头像 URL
   * @property {string} description 描述
   * @property {Region} region 区域
   * @property {string} homepage 主页
   * @property {string} videoUrl 视频 URL
   * @property {Array<Product>} products 产品
   */

  function fetchUsersData() {
    return [
      {
        id: "sour_c_andy",
        name: "sour_c_andy",
        avatarUrl: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/sour_c_andy.jpg?v=1769398820",
        region: null,
        videoUrl: "https://cdn.shopify.com/videos/c/o/v/934ab318192449c09748db799261cc64.mp4",
      },
      {
        id: "yolk.ii",
        name: "yolk.ii",
        avatarUrl: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/vga_avatar_yolk.ii.png?v=1757409676",
        region: {
          country: "Canada",
          x: 186,
          y: 173,
        },
        homepage: "https://ko-fi.com/K3K7IO56D/shop",
        description: "Is a Canadian digital artist recognized for character-focused illustrations and animations. ",
        videoUrl: "https://cdn.shopify.com/videos/c/o/v/c66f2fc25dc04732bb06be2cec60d438.mp4",
        products: [
          {
            image: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/yolk2.png?v=1757492279",
            description:
              "Hey guys! Its JJ, mostly known as yolk.ii. Im an 18 year old artist from canada.\nEver since I could remember I've been creating art, Ive explored many side quests and different mediums and styles slowly leveling up eventually leading me to posting my characters and selling trinkets and designs online. Every project feels like unlocking an achievement!\nThrough my art journey vograce has worked with me various times, their site has allowed me to create many diverse trinkets. Their quality is incredible, the options available make the experience feel like in game customizations. Working with them I've never encountered a problem, they are trustworthy to team up with for further quests! My personal favourite is their epoxy keychain, collecting them feels like I'm collecting Enchanted items from my favourite games!\nThe best part is how easy it is to navigate the site as well as how accessible it is to any level players as they have now lowered their minimum quantity for acrylic keychains/ standees and pins to just one piece!\nI look forward to every new upgrade they make!\nWe make it real together. ",
          },
        ],
      },
      {
        id: "kasscabel",
        name: "kasscabel",
        avatarUrl: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/vga_avatar_kasscabel.jpg?v=1769175051",
        region: {
          country: "AUS",
          x: 1010,
          y: 478,
        },
        homepage: "",
        description: "sketch artist | furry animator",
        videoUrl: "https://cdn.shopify.com/videos/c/o/v/83f419eb93e84996ad423c1fb900a851.mp4",
        products: [
          {
            image: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/kasscabel.jpg?v=1769175052",
            description:
              "vograce offers a really easy way to turn your art into merch! the prices are really good and the end results look extremely clean and professional. if u wanna know more about it check the video i posted !",
          },
        ],
      },
      {
        id: "julia_gisella",
        name: "julia_gisella",
        avatarUrl: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/vga_avatar_julia_gisella.png?v=1757409679",
        region: {
          country: "United Kingdom",
          x: 536,
          y: 174,
        },
        homepage: "https://www.juliagisella.com",
        description:
          "Julia Gisella is known and famous as an Artist, Instagrammer, YouTuber, and well-known social media influencer by profession. Julia Gisella is popularly known for her innovative art videos in which she draws and blends celebrities.",
        videoUrl: "https://cdn.shopify.com/videos/c/o/v/645e8bb12558464a9aed94186049cbde.mp4",
        products: [
          {
            image: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/vga_Julia-2.png?v=1757397267",
            description: "",
          },
        ],
      },
      {
        id: "the_little_toot",
        name: "the_little_toot",
        avatarUrl: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/vga_avatar_the_little_toot.png?v=1757409678",
        region: {
          country: "United Kingdom",
          x: 540,
          y: 196,
        },
        homepage: "",
        description:
          "little toot, a non binary digital artist and clown enthusiast from the UK. Well known for my fast food mascot and LGBTQ+ art",
        videoUrl: "https://cdn.shopify.com/videos/c/o/v/9c3d03cb4c364ab9ae3135c98f298593.mp4",
        products: [
          {
            image: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/vga_the_little_toot-1.png?v=1757397249",
            description:
              "I was contacted by Vograce last year and have had the pleasure to work with them on many occasions! They have all been kind and patient with my needs and given me so many lovely opportunities to showcase my work! (Check out my profile!) \nThe website is simple and clean to navigate and thanks to the step by step links and videos, making merch with Vograce is easy!",
          },
        ],
      },
      {
        id: "creamimy",
        name: "creamimy",
        avatarUrl: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/vga_avatar_creamimy.png?v=1757409678",
        region: {
          country: "France",
          x: 554,
          y: 221,
        },
        homepage: "https://creamimy.com/",
        description:
          "Creamimy is a French artist with a global following of over 5 million subscribers. As a passionate Disney fan, she shares her original creations with audiences worldwide, blending artistry with imagination to bring joy and inspiration to her community.",
        videoUrl: "https://cdn.shopify.com/videos/c/o/v/cc444c6055354ef2a16df50bf544d5c3.mp4",
        products: [
          {
            image: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/vga_Creamimy-3.png?v=1757397248",
            description:
              "Thank you Vograce for this collaboration, we have been working together for a few years now, and I am still amazed by the products you create for me. I am delighted to be able to offer my customers such high-quality products.",
          },
        ],
      },
      {
        id: "xMaruu11",
        name: "xMaruu11",
        avatarUrl: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/vga_avatar_xMaruu11.png?v=1757409675",
        region: {
          country: "Texas, United States",
          x: 230,
          y: 290,
        },
        homepage: "",
        description:
          "Maruu is a professional animator and comic creator. She has been working on her webcomic Double Hearted with her friend Kitsuneisi. Thanks to VOGRACE, they are now able to launch their own merch shop to support their story.",
        videoUrl: "https://cdn.shopify.com/videos/c/o/v/c1b3847aff274468b9cb7667abb9fd61.mp4",
        products: [
          {
            image:
              "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/vga_xMaruu11-2_75bc767c-7024-40e5-a89b-c4e1c9b55a18.png?v=1757397235",
            description:
              "Vograce has been a huge support for us, bringing amazing quality products, but most importantly, amazing 1 on 1 services and helping us with any issues or questions we had. Helping us create exactly what we had in mind. I believe that's a hidden gem a lot of people tend to gloss over",
          },
        ],
      },
      {
        id: "iikawarii",
        name: "iikawarii",
        avatarUrl: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/vga_avatar_iikawarii.png?v=1757409677",
        region: {
          country: "Florida, United States",
          x: 280,
          y: 306,
        },
        homepage: "https://www.etsy.com/shop/iikawarii/?etsrc=sdt",
        description:
          "Kawari is a freelance illustrator and merch designer, known as “your local cyber vampire.” They run their own store, @iikawarii, and have a passion for nostalgic and cute art from around the world. Their work is inspired by classic magical girl anime and Western cartoons from their childhood.",
        videoUrl: "",
        products: [
          {
            image:
              "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/vga_iikawarii-2_95efbbb0-9b6e-4e07-8f4f-563dbe7dfe3b.png?v=1757397241",
            description:
              "Collaborating with Vograce has been a very fun and user-friendly experience! The service I've had is exceptional. Talking with reps either through social media or email has always been an easy and friendly process. Any time I've had an after-sales issue, it's been swiftly handled. It's been exciting to continue to evolve my art into a new form. I hope to continue creating new art and transforming it with Vograce! \n\nI started working with Vograce in 2023. I was exploring ways to turn my art into keychains, and found their website easy to access and understand. Since then, I've been a regular Vograce customer, even working with Vograce for products I never knew I could make, like tote bags and stickers! There's always been something new coming out for me to look forward to and consider the creative possibilities with. \n\nWhether it's a new button pin shape, acrylic technique, or a whole new product, I'm always eager to see what is new each month. For anyone looking to try something new with their art, or interested in leveling up their merch, Vograce can help!",
          },
        ],
      },
      // {
      //   id: "Zippkey",
      //   name: "Zippkey",
      //   avatarUrl:
      //     "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/vga_avatar_Zippkey.png?v=1757409675",
      //   region: {
      //     country: "California, United States",
      //     x: 153,
      //     y: 273,
      //   },
      //   homepage: "",
      //   description: "",
      //   videoUrl: "",
      //   products: [],
      // },
      {
        id: "sunniyuki_arts",
        name: "sunniyuki_arts",
        avatarUrl: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/vga_avatar_sunniyuki_arts.png?v=1757409680",
        region: {
          country: "Glenelg North, Australia",
          x: 1021,
          y: 538,
        },
        homepage: "https://www.etsy.com/au/shop/Sunniyuki",
        description:
          "Sunniyuki (Sunny) is a freelance artist from Australia. Their art is inspired by video games such as Honkai: Star Rail, Genshin Impact, Wuthering Waves, Love and Deepspace, and by anime.",
        videoUrl: "https://cdn.shopify.com/videos/c/o/v/d3f531419e07477a87c8edb6a71ab7e2.mp4",
        products: [
          {
            image: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/vga_sunniyuki_arts-2.png?v=1757397257",
            description:
              "My business began after attending a convention with an artist alley, motivating me to connect with people by creating merch from the media I love. \n\nVograce was the very first manufacturer that I tried, since I had heard so many great things about their products and variety. I remember when my first order arrived, I was extremely pleased with the quality and seeing my art truly come to life. Since then, I've used Vograce for my keychains, stickers, photocards, and tote bags. My customers and friends often comment on the quality of the products! I especially like Vograce's low MOQ and option to include different designs in one order, it makes stocking up so much easier (plus, the discounts for the larger orders are a huge bonus!). \n\nAdditionally, the proofing staff are always super patient and professional, which adds to the stress-free process. I'm excited to explore more of their products in the future, including enamel pins and acrylic stands. Vograce has such a wide range of items that I've ordered products that I would have never considered before. \n\nIt really opens up a lot of possibilities! I truly recommend Vograce to any artist or small business to make their art come to life :D",
          },
        ],
      },
      {
        id: "bolzanpaula",
        name: "bolzanpaula",
        avatarUrl: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/vga_avatar_bolzanpaula.png?v=1757409678",
        region: {
          country: "Argentina",
          x: 339,
          y: 524,
        },
        homepage: "",
        description:
          "Pau Bolzan, an Argentinean artist and YouTuber. I started as an artist selling my work but when it fusioned with social media it all started to work out. I started showing my art and making videos about it and a big audience started growing.",
        videoUrl: "https://cdn.shopify.com/videos/c/o/v/5bbc97961f82475e83a5f3ccd48fc6cc.mp4",
        products: [
          {
            image: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/bolzanpaula.png?v=1757492409",
            description:
              "It has always been amazing. The first time I made an order and received it, I don't know what I was expecting, but the products were so high quality I was amazed. \nRight now I've been using Vograce for a long time and I would not change it for anything, the service, the website, the products, everything is so high quality. I could make things I didn't know were possible with my art.",
          },
        ],
      },
      {
        id: "s33lpup",
        name: "s33lpup",
        avatarUrl: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/vga_avatar_s33lpup.jpg?v=1769174580",
        region: {
          country: "USA",
          x: 210,
          y: 260,
        },
        homepage: "",
        description:
          "Is a digital artist known for original character illustrations with a distinctive, stylized visual identity.",
        videoUrl: "",
        products: [
          {
            image: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/s33lpup.jpg?v=1769174691",
            description:
              "Vograce is an accessible and easy to use platform if you’re ever interested in creating physical merchandise! With a diverse range of products, ranging from keychains, to prints, and even plushies; the possibilities of what to create is practically limitless!!! With a low MOQ as well, it’s easy to create your own personalized products for yourself, your friends, and family. Vograce is very easy to navigate with clear and concise instructions, and customer service is very quick and helpful, making sure your product will fit your expectations.",
          },
        ],
      },
      {
        id: "nouconcept",
        name: "nouconcept",
        avatarUrl: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/vga_avatar_nouconcept.jpg?v=1769175051",
        region: {
          country: "ESP",
          x: 544,
          y: 251,
        },
        homepage: "",
        description: "Digital artist and art tips",
        videoUrl: "",
        products: [
          {
            image: "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/nouconcept.jpg?v=1769175052",
            description: "All my stickers from Vograce!! They ship pretty fast and their holo is super good quality",
          },
        ],
      },
    ];
  }

  /**
   * VGARegion 配置类
   */
  class VGARegionConfig {
    static DEFAULTS = {
      AUTO_SHOW_INTERVAL: 2000, // 自动显示间隔（毫秒）
      ANIMATION_DURATION: 300, // 动画时长（毫秒）
      HIDE_DELAY: 300, // 隐藏延迟（毫秒）
      AUTO_HIDE_DELAY: 3000, // 自动隐藏延迟（毫秒）
      DESIGN_WIDTH: 1200, // 设计稿宽度
      DESIGN_HEIGHT: 650, // 设计稿高度
      MIN_DISTANCE: 20, // 点距离边界最小距离
    };

    static SELECTORS = {
      BACKGROUND: ".vga-regions-map__background",
      FOREGROUND: ".vga-regions-map__foreground",
      POINT: ".vga-regions-map__point",
      POPOVER: ".vga-popover",
      POPOVER_BUTTON: ".vga-popover__button",
      DRAWER: ".vograce-drawer",
    };

    static CLASSES = {
      POINT: "vga-regions-map__point",
      POPOVER: "vga-popover",
      POPOVER_OPEN: "vga-popover--open",
      POPOVER_FADING_OUT: "vga-popover--fading-out",
      POPOVER_FADING_IN: "vga-popover--fading-in",
    };

    constructor(options = {}) {
      Object.assign(this, VGARegionConfig.DEFAULTS, options);
    }
  }

  /**
   * VGARegion 状态管理类
   */
  class VGARegionState {
    constructor() {
      this.users = [];
      this.activeUser = null;
      this.screenWidth = 0;
      this.screenHeight = 0;
      this.isPaused = false;
      this.isHoveringPopover = false;
      this.isDrawerOpen = false;
      this.isAnimating = false;
      this.isInitialized = false;

      // 新增：跟踪已显示的用户
      this.shownUserIds = new Set();
      this.availableUsers = [];
    }

    setUsers(users) {
      this.users = [...users];
      // 重新初始化可用用户列表
      this.resetAvailableUsers();
    }

    setActiveUser(user) {
      this.activeUser = user;
      if (user) {
        // 将当前用户标记为已显示
        this.shownUserIds.add(user.id);
        this.updateAvailableUsers();
      }
    }

    setScreenSize(width, height) {
      this.screenWidth = width;
      this.screenHeight = height;
    }

    pause() {
      this.isPaused = true;
    }

    resume() {
      if (!this.isHoveringPopover && !this.isDrawerOpen) {
        this.isPaused = false;
      }
    }

    /**
     * 重置可用用户列表
     */
    resetAvailableUsers() {
      this.availableUsers = [...this.users];
      this.shownUserIds.clear();
    }

    /**
     * 更新可用用户列表
     */
    updateAvailableUsers() {
      this.availableUsers = this.users.filter((user) => !this.shownUserIds.has(user.id));

      // 如果所有用户都显示过了，重置列表
      if (this.availableUsers.length === 0) {
        console.log("VGARegion: All users shown, resetting rotation");
        this.resetAvailableUsers();
      }
    }

    /**
     * 获取下一个未显示的用户（智能随机）
     */
    getRandomUser() {
      if (!this.users.length) return null;

      // 如果可用用户列表为空，重置
      if (this.availableUsers.length === 0) {
        this.resetAvailableUsers();
      }

      // 从未显示的用户中随机选择
      const randomIndex = Math.floor(Math.random() * this.availableUsers.length);
      const selectedUser = this.availableUsers[randomIndex];

      console.log(`VGARegion: Selected user ${selectedUser.name}, remaining: ${this.availableUsers.length - 1}`);
      return selectedUser;
    }

    /**
     * 获取已显示用户的统计信息
     */
    getDisplayStats() {
      return {
        total: this.users.length,
        shown: this.shownUserIds.size,
        remaining: this.availableUsers.length,
        completedRounds: Math.floor(this.shownUserIds.size / this.users.length),
      };
    }

    reset() {
      this.isPaused = false;
      this.isHoveringPopover = false;
      this.isDrawerOpen = false;
      this.isAnimating = false;
      this.activeUser = null;
      // 重置显示记录
      this.resetAvailableUsers();
    }
  }

  /**
   * VGARegion 动画管理类
   */
  class VGARegionAnimator {
    constructor(config) {
      this.config = config;
    }

    /**
     * 等待过渡动画完成
     */
    waitForTransition(duration = this.config.ANIMATION_DURATION) {
      return new Promise((resolve) => setTimeout(resolve, duration));
    }

    /**
     * 显示 popover 并添加动画
     */
    showPopover(popover) {
      _.addClass(popover, VGARegionConfig.CLASSES.POPOVER_OPEN);
    }

    /**
     * 隐藏 popover 并添加动画
     */
    async hidePopover(popover) {
      _.addClass(popover, VGARegionConfig.CLASSES.POPOVER_FADING_OUT);
      await this.waitForTransition();
      _.removeClass(popover, VGARegionConfig.CLASSES.POPOVER_OPEN);
      _.removeClass(popover, VGARegionConfig.CLASSES.POPOVER_FADING_OUT);
      _.removeClass(popover, VGARegionConfig.CLASSES.POPOVER_FADING_IN);
    }

    /**
     * 执行切换动画
     */
    async switchContent(popover, updateContent) {
      // 淡出
      _.addClass(popover, VGARegionConfig.CLASSES.POPOVER_FADING_OUT);
      _.removeClass(popover, VGARegionConfig.CLASSES.POPOVER_FADING_IN);
      await this.waitForTransition();

      // 更新内容
      updateContent();

      // 淡入
      _.removeClass(popover, VGARegionConfig.CLASSES.POPOVER_FADING_OUT);
      _.addClass(popover, VGARegionConfig.CLASSES.POPOVER_FADING_IN);
      await this.waitForTransition();
    }
  }

  /**
   * VGARegion 事件管理类
   */
  class VGARegionEventManager {
    constructor(region) {
      this.region = region;
      this.boundMethods = new Map();
    }

    /**
     * 获取绑定的方法引用
     */
    getBoundMethod(name, method) {
      if (!this.boundMethods.has(name)) {
        this.boundMethods.set(name, method.bind(this.region));
      }
      return this.boundMethods.get(name);
    }

    /**
     * 绑定事件
     */
    bindEvents() {
      if (_.isMobile()) {
        this.bindMobileEvents();
      } else {
        this.bindDesktopEvents();
      }

      _.on(document.body, "click", this.getBoundMethod("clickBody", this.region._handleBodyClick));
      _.on(window, "resize", this.getBoundMethod("resize", this.region._handleResize));
    }

    /**
     * 解绑事件
     */
    unbindEvents() {
      _.$$(VGARegionConfig.SELECTORS.POINT).forEach((point) => {
        _.off(point, "click", this.getBoundMethod("clickPoint", this.region._handlePointClick));
        _.off(point, "mouseenter", this.getBoundMethod("hoverPoint", this.region._handlePointHover));
        _.off(point, "mouseleave", this.getBoundMethod("leavePoint", this.region._handlePointLeave));
      });

      if (this.region.$popover) {
        _.off(this.region.$popover, "click", this.getBoundMethod("clickPopover", this.region._handlePopoverClick));
        _.off(this.region.$popover, "mouseenter", this.getBoundMethod("hoverPopover", this.region._handlePopoverHover));
        _.off(this.region.$popover, "mouseleave", this.getBoundMethod("leavePopover", this.region._handlePopoverLeave));
      }

      _.off(document.body, "click", this.getBoundMethod("clickBody", this.region._handleBodyClick));
      _.off(window, "resize", this.getBoundMethod("resize", this.region._handleResize));
    }

    bindMobileEvents() {
      _.$$(VGARegionConfig.SELECTORS.POINT).forEach((point) => {
        _.on(point, "click", this.getBoundMethod("clickPoint", this.region._handlePointClick));
      });
    }

    bindDesktopEvents() {
      _.$$(VGARegionConfig.SELECTORS.POINT).forEach((point) => {
        _.on(point, "mouseenter", this.getBoundMethod("hoverPoint", this.region._handlePointHover));
        _.on(point, "mouseleave", this.getBoundMethod("leavePoint", this.region._handlePointLeave));
      });

      if (this.region.$popover) {
        _.on(this.region.$popover, "click", this.getBoundMethod("clickPopover", this.region._handlePopoverClick));
        _.on(this.region.$popover, "mouseenter", this.getBoundMethod("hoverPopover", this.region._handlePopoverHover));
        _.on(this.region.$popover, "mouseleave", this.getBoundMethod("leavePopover", this.region._handlePopoverLeave));
      }
    }

    destroy() {
      this.unbindEvents();
      this.boundMethods.clear();
    }
  }

  /**
   * VGARegion 主类
   */
  class VGARegion {
    /**
     * @constructor
     * @param {Array<User>} users
     */
    constructor(users, options = {}) {
      // 初始化配置
      this.config = new VGARegionConfig(options);

      // 初始化状态
      this.state = new VGARegionState();
      this.state.setUsers(users.filter((user) => user.region));

      // 初始化动画管理器
      this.animator = new VGARegionAnimator(this.config);

      // 初始化定时器
      this.timers = {
        autoShow: null,
        hide: null,
        autoHide: null,
      };

      // 初始化观察器
      this.observers = {
        drawer: null,
        drawerRemoval: new Set(),
      };

      // 初始化DOM元素
      this._initializeElements();

      // 初始化事件管理器
      this.eventManager = new VGARegionEventManager(this);

      // 初始化组件
      this._initialize();
    }

    /**
     * 初始化DOM元素
     */
    _initializeElements() {
      this.$background = _.$(VGARegionConfig.SELECTORS.BACKGROUND);
      this.$foreground = _.$(VGARegionConfig.SELECTORS.FOREGROUND);
      this.$popover = null; // 将在 setupPopover 中创建

      // 验证必要元素
      if (!this.$background || !this.$foreground) {
        throw new Error("VGARegion: Required DOM elements not found");
      }
    }

    /**
     * 初始化组件
     */
    _initialize() {
      try {
        this._resize();
        this._startAutoShow();
        this._watchDrawerState();
        this.state.isInitialized = true;
      } catch (error) {
        console.error("VGARegion initialization failed:", error);
      }
    }

    /**
     * 响应式调整大小
     */
    _resize() {
      try {
        this.eventManager.unbindEvents();
        this._clearForeground();

        this._updateScreenSize();
        this._adaptPositionsForCurrentScreen();
        this._setupPoints();
        this._setupPopover();
        this.eventManager.bindEvents();
      } catch (error) {
        console.error("VGARegion resize failed:", error);
      }
    }

    /**
     * 清空前景元素
     */
    _clearForeground() {
      if (this.$foreground) {
        this.$foreground.innerHTML = "";
      }
    }

    /**
     * 更新屏幕尺寸
     */
    _updateScreenSize() {
      const width = this.$background?.clientWidth || this.$background?.offsetWidth || 0;
      const height = this.$background?.clientHeight || this.$background?.offsetHeight || 0;
      this.state.setScreenSize(width, height);
    }

    /**
     * 处理Body点击事件
     */
    _handleBodyClick(e) {
      const target = e.target.closest(".vograce-button[data-control='spread']");
      if (!target) return;

      const selector = ".vga-drawer__product-description";
      const sibling = _.getSiblingElement(target, selector);
      if (!sibling) return;

      _.removeClass(sibling, "vograce-line-clamp-3");
      target.remove();
    }

    /**
     * 处理窗口大小调整事件
     */
    _handleResize() {
      // 防抖处理
      this._clearTimer("resize");
      this.timers.resize = setTimeout(() => this._resize(), 100);
    }

    /**
     * 根据当前屏幕适配位置
     */
    _adaptPositionsForCurrentScreen() {
      const users = this.state.users;
      const { screenWidth, screenHeight } = this.state;

      if (!users.length || !screenWidth || !screenHeight) return;

      const scaleX = screenWidth / this.config.DESIGN_WIDTH;
      const scaleY = screenHeight / this.config.DESIGN_HEIGHT;

      users.forEach((user) => {
        if (!user.region.designX) {
          user.region.designX = user.region.x;
          user.region.designY = user.region.y;
        }

        const rx = Math.round(user.region.designX * scaleX);
        const ry = Math.round(user.region.designY * scaleY);

        user.region.x = Math.max(this.config.MIN_DISTANCE, Math.min(rx, screenWidth - this.config.MIN_DISTANCE));
        user.region.y = Math.max(this.config.MIN_DISTANCE, Math.min(ry, screenHeight - this.config.MIN_DISTANCE));
        user.region.originalX = user.region.x;
        user.region.originalY = user.region.y;
      });
    }

    /**
     * 设置地图点
     */
    _setupPoints() {
      if (!this.state.users.length) return;

      const fragment = document.createDocumentFragment();

      this.state.users.forEach((user) => {
        const button = this._createPointElement(user);
        fragment.appendChild(button);
      });

      this.$foreground.appendChild(fragment);
      _.show(this.$foreground);
    }

    /**
     * 创建点元素
     */
    _createPointElement(user) {
      return _.createElement("button", {
        class: VGARegionConfig.CLASSES.POINT,
        data: { id: user.id },
        style: {
          left: `${user.region.x}px`,
          top: `${user.region.y}px`,
        },
        "aria-label": `${user.name} in ${user.region.country}`,
      });
    }

    /**
     * 设置弹出框
     */
    _setupPopover() {
      if (_.isMobile()) return;

      const popover = _.createElement("div", {
        class: VGARegionConfig.CLASSES.POPOVER,
        "aria-hidden": "true",
      });

      this.$foreground.appendChild(popover);
      this.$popover = popover;
    }

    /**
     * 处理点击事件
     */
    _handlePointClick(e) {
      try {
        const target = e.target;
        const id = _.dataset(target, "id");
        const user = this._findUserById(id);

        if (!user) {
          console.warn(`VGARegion: User not found for id: ${id}`);
          return;
        }

        this.state.setActiveUser(user);

        _.showPopup({
          id: "VGA-POPUP",
          content: this._buildDrawerContent(),
          buildConfirmButton: () => this._buildConfirmButton(user),
        });
      } catch (error) {
        console.error("VGARegion point click error:", error);
      }
    }

    /**
     * 处理悬停事件
     */
    _handlePointHover(e) {
      try {
        const target = e.target.closest(VGARegionConfig.SELECTORS.POINT);
        if (!target) return;

        // 清除隐藏定时器
        this._clearTimer("hide");

        const id = _.dataset(target, "id");
        const user = this._findUserById(id);
        if (!user) return;

        this.state.setActiveUser(user);
        this._showPopoverAtPoint(user, target);
      } catch (error) {
        console.error("VGARegion point hover error:", error);
      }
    }

    /**
     * 处理离开点事件
     */
    _handlePointLeave(e) {
      const target = e.target.closest(VGARegionConfig.SELECTORS.POINT);
      if (!target) return;

      this.timers.hide = setTimeout(() => {
        if (this.$popover && !this.state.isHoveringPopover) {
          this.animator.hidePopover(this.$popover);
        }
      }, this.config.HIDE_DELAY);
    }

    /**
     * 处理悬停 popover 事件
     */
    _handlePopoverHover() {
      this._clearTimer("hide");
      this.state.isHoveringPopover = true;
      this.state.pause();
    }

    /**
     * 处理离开 popover 事件
     */
    _handlePopoverLeave() {
      if (this.state.isAnimating) return;

      this.state.isHoveringPopover = false;
      this.state.resume();
    }

    /**
     * 处理 popover 点击事件
     */
    _handlePopoverClick(e) {
      const target = e.target.closest(VGARegionConfig.SELECTORS.POPOVER_BUTTON);
      if (!target) return;

      try {
        this.state.isDrawerOpen = true;
        this.state.pause();

        _.showDrawer({
          id: "VGA-DRAWER",
          content: this._buildDrawerContent(),
        });
      } catch (error) {
        console.error("VGARegion popover click error:", error);
      }
    }

    /**
     * 查找用户
     */
    _findUserById(id) {
      return this.state.users.find((user) => user.id === id);
    }

    /**
     * 在指定点显示 popover
     */
    _showPopoverAtPoint(user, pointElement) {
      if (!this.$popover) return;

      this.$popover.innerHTML = this._buildPopoverContent(user);

      _.css(this.$popover, {
        top: `${pointElement.offsetTop}px`,
        left: `${pointElement.offsetLeft}px`,
      });

      this.animator.showPopover(this.$popover);
    }

    /**
     * 清除定时器
     */
    _clearTimer(name) {
      if (this.timers[name]) {
        clearTimeout(this.timers[name]);
        this.timers[name] = null;
      }
    }

    /**
     * 清除所有定时器
     */
    _clearAllTimers() {
      Object.keys(this.timers).forEach((name) => this._clearTimer(name));
    }

    /**
     * 创建确认按钮
     */
    _buildConfirmButton(user) {
      if (!user?.homepage) return _.createElement("div");

      return _.createElement(
        "a",
        {
          href: user.homepage,
          target: "_blank",
          class: [
            "vograce-button",
            "vograce-button--default",
            "vograce-button--solid",
            "vograce-button--rounded",
            "vograce-button--block",
            "vga-popup-button",
          ].join(" "),
          "aria-label": `Visit ${user.name}'s homepage`,
        },
        "<span>Check More</span>"
      );
    }

    /**
     * 启动自动显示功能
     */
    _startAutoShow() {
      if (_.isMobile() || !this.state.users.length) return;

      this.timers.autoShow = setInterval(() => {
        if (!this.state.isPaused) {
          this._showRandomUserPopover();
        }
      }, this.config.AUTO_SHOW_INTERVAL);
    }

    /**
     * 停止自动显示功能
     */
    async _stopAutoShow() {
      this._clearTimer("autoShow");

      if (this.$popover) {
        await this.animator.hidePopover(this.$popover);
      }
    }

    /**
     * 随机显示用户 popover
     */
    async _showRandomUserPopover() {
      if (!this.state.users.length || this.state.isPaused || this.state.isAnimating) {
        return;
      }

      try {
        this.state.isAnimating = true;

        const randomUser = this.state.getRandomUser();
        if (!randomUser) return;

        const pointElement = _.$(`[data-id="${randomUser.id}"]`);
        if (!pointElement) return;

        // 如果当前没有显示 popover，直接显示
        if (!_.hasClass(this.$popover, VGARegionConfig.CLASSES.POPOVER_OPEN)) {
          this.state.setActiveUser(randomUser); // 这里会自动标记为已显示
          this._showPopoverAtPoint(randomUser, pointElement);
        } else {
          // 有 popover 显示时，执行切换动画
          await this.animator.switchContent(this.$popover, () => {
            this.state.setActiveUser(randomUser); // 这里会自动标记为已显示
            this.$popover.innerHTML = this._buildPopoverContent(randomUser);
            _.css(this.$popover, {
              top: `${pointElement.offsetTop}px`,
              left: `${pointElement.offsetLeft}px`,
            });
          });
        }

        // 可选：显示统计信息（调试用）
        if (console.log) {
          const stats = this.state.getDisplayStats();
          console.log(`VGARegion Stats: ${stats.shown}/${stats.total} shown, ${stats.remaining} remaining`);
        }
      } catch (error) {
        console.error("VGARegion random show error:", error);
      } finally {
        this.state.isAnimating = false;
      }
    }

    /**
     * 监听 drawer 状态变化
     */
    _watchDrawerState() {
      this.observers.drawer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList") {
            mutation.addedNodes.forEach((node) => {
              if (this._isDrawerElement(node)) {
                this.state.isDrawerOpen = true;
                this.state.pause();
                this._watchDrawerRemoval(node);
              }
            });
          }
        });
      });

      this.observers.drawer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    /**
     * 检查是否为 drawer 元素
     */
    _isDrawerElement(node) {
      return node.nodeType === Node.ELEMENT_NODE && node.classList && node.classList.contains("vograce-drawer");
    }

    /**
     * 监听 drawer 移除
     */
    _watchDrawerRemoval(drawerElement) {
      const removalObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList") {
            mutation.removedNodes.forEach((node) => {
              if (node === drawerElement) {
                this.state.isDrawerOpen = false;
                this.state.resume();
                removalObserver.disconnect();
                this.observers.drawerRemoval.delete(removalObserver);
              }
            });
          }
        });
      });

      removalObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });

      this.observers.drawerRemoval.add(removalObserver);
    }

    /**
     * 构建抽屉内容
     */
    _buildDrawerContent() {
      const user = this.state.activeUser;
      if (!user) {
        console.warn("VGARegion: No active user for drawer content");
        return "<div>No user data available</div>";
      }

      try {
        const snippets = [
          `<div class="vograce-flex vograce-items-center vga-drawer__user">
            <div class="vograce-flex-0 vograce-avatar vga-drawer__avatar">
              <img class="vograce-avatar__inner" src="${user.avatarUrl}" alt="${user.name}" loading="lazy" />
            </div>
            <div class="vograce-flex vograce-flex-col vograce-flex-1 vograce-justify-center">
              <span class="vograce-typography vga-drawer__nickname">${user.name}</span>
              <span class="vograce-typography vga-drawer__region">${user.region.country}</span>
            </div>
          </div>`,
        ];

        if (user.description) {
          const formattedDescription = _.nl2br(user.description);
          snippets.push(`<p class="vograce-typography vga-drawer__description">${formattedDescription}</p>`);
        }

        if (_.isMobile()) {
          snippets.push('<div class="vga-drawer__scroll">');
        }

        if (user.videoUrl) {
          snippets.push(
            `<div class="vga-drawer__video"><video src="${user.videoUrl}" controls preload="metadata"></video></div>`
          );
        }

        if (user.products?.length > 0) {
          const productItems = user.products.map((product) => this._buildProduct(product, user)).join("");
          snippets.push(`<ul class="vga-drawer__products">${productItems}</ul>`);
        }

        if (_.isMobile()) {
          snippets.push("</div>");
        }

        return snippets.join("");
      } catch (error) {
        console.error("VGARegion drawer content build error:", error);
        return "<div>Error loading user content</div>";
      }
    }

    /**
     * 构建产品项
     */
    _buildProduct(product, user) {
      if (!product || !user) return "";

      try {
        const snippets = [
          '<li class="vograce-flex vga-drawer__product">',
          `<div class="vograce-flex-0 vograce-image vga-drawer__product-img"><img class="vograce-image__inner" src="${product.image}" loading="lazy" /></div>`,
          '<div class="vograce-flex vograce-flex-col vograce-flex-1">',
          '<div class="vograce-flex vga-drawer__product-user">',
          `<div class="vograce-flex-0 vograce-avatar vga-drawer__product-avatar"><img class="vograce-avatar__inner" src="${user.avatarUrl}" loading="lazy" /></div>`,
          `<span class="vga-drawer__product-nickname vograce-typography vograce-flex-1">${user.name}</span></div>`,
        ];

        if (product.description) {
          const formattedDescription = _.nl2br(product.description);
          snippets.push(`<div class="vograce-flex vograce-flex-col vograce-items-end">
            <p class="vga-drawer__product-description vograce-typography vograce-line-clamp-3">${formattedDescription}</p>
            <button type="button" class="vograce-button vograce-button--primary vograce-button--text vograce-button--small" data-control="spread" aria-label="Expand description">
              <span>Spread</span>
            </button>
          </div>`);
        }

        if (user.homepage) {
          snippets.push(`<a href="${user.homepage}" target="_blank" rel="noopener noreferrer" class="vograce-button vograce-button--solid vograce-button--default vograce-button--rounded vga-drawer__product-button" aria-label="Visit ${user.name}'s page">
            <span>Check More</span>
          </a>`);
        }

        snippets.push("</div></li>");
        return snippets.join("");
      } catch (error) {
        console.error("VGARegion product build error:", error);
        return "";
      }
    }

    /**
     * 构建弹出框内容
     */
    _buildPopoverContent(user = this.state.activeUser) {
      if (!user) {
        console.warn("VGARegion: No user for popover content");
        return "<div>No user data available</div>";
      }

      try {
        const snippets = [
          `<div class="vograce-flex vograce-items-center vga-popover__user">
            <div class="vograce-flex-0 vograce-avatar vga-popover__avatar">
              <img class="vograce-avatar__inner" src="${user.avatarUrl}" alt="${user.name}" loading="lazy" />
            </div>
            <div class="vograce-flex vograce-flex-col vograce-flex-1">
              <span class="vograce-typography vograce-popover__name">${user.name}</span>
              <span class="vograce-typography vga-popover__region">${user.region.country}</span>
            </div>
          </div>`,
        ];

        if (user.description) {
          const formattedDescription = _.nl2br(user.description);
          snippets.push(`<p class="vograce-typography vga-popover__description">${formattedDescription}</p>`);
        }

        snippets.push(`<button type="button" class="vograce-button vograce-button--default vograce-button--solid vograce-button--square vograce-button--block vga-popover__button" aria-label="View more details for ${user.name}">
          <span>Check More</span>
        </button>`);

        return snippets.join("");
      } catch (error) {
        console.error("VGARegion popover content build error:", error);
        return "<div>Error loading user content</div>";
      }
    }

    /**
     * 公共接口：获取配置
     */
    getConfig() {
      return { ...this.config };
    }

    /**
     * 公共接口：获取状态
     */
    getState() {
      const stats = this.state.getDisplayStats();
      return {
        isInitialized: this.state.isInitialized,
        isPaused: this.state.isPaused,
        isAnimating: this.state.isAnimating,
        activeUser: this.state.activeUser,
        userCount: this.state.users.length,
        displayStats: stats,
      };
    }

    /**
     * 公共接口：重置用户显示循环
     */
    resetRotation() {
      this.state.resetAvailableUsers();
      console.log("VGARegion: User rotation reset");
    }

    /**
     * 公共接口：更新用户数据
     */
    updateUsers(users) {
      if (!Array.isArray(users)) {
        console.warn("VGARegion: Users must be an array");
        return;
      }

      this.state.setUsers(users);
      if (this.state.isInitialized) {
        this._resize(); // 重新初始化点
      }
    }

    /**
     * 公共接口：手动显示用户
     */
    showUser(userId) {
      const user = this._findUserById(userId);
      if (!user) {
        console.warn(`VGARegion: User ${userId} not found`);
        return false;
      }

      const pointElement = _.$(`[data-id="${userId}"]`);
      if (!pointElement) {
        console.warn(`VGARegion: Point element for user ${userId} not found`);
        return false;
      }

      this.state.setActiveUser(user);
      this._showPopoverAtPoint(user, pointElement);
      return true;
    }

    /**
     * 公共接口：隐藏 popover
     */
    async hidePopover() {
      if (this.$popover) {
        await this.animator.hidePopover(this.$popover);
      }
    }

    /**
     * 公共接口：暂停/恢复自动显示
     */
    pause() {
      this.state.pause();
    }

    resume() {
      this.state.resume();
    }

    /**
     * 销毁实例
     */
    async destroy() {
      try {
        // 停止自动显示
        await this._stopAutoShow();

        // 清理事件管理器
        if (this.eventManager) {
          this.eventManager.destroy();
          this.eventManager = null;
        }

        // 清理观察器
        if (this.observers.drawer) {
          this.observers.drawer.disconnect();
          this.observers.drawer = null;
        }

        // 清理所有 drawer 移除观察器
        this.observers.drawerRemoval.forEach((observer) => {
          observer.disconnect();
        });
        this.observers.drawerRemoval.clear();

        // 清理所有定时器
        this._clearAllTimers();

        // 重置状态
        this.state.reset();

        // 清理 DOM 元素引用
        this.$background = null;
        this.$foreground = null;
        this.$popover = null;

        console.log("VGARegion destroyed successfully");
      } catch (error) {
        console.error("VGARegion destroy error:", error);
      }
    }
  }

  class VGAIntro {
    /**
     * @type {Array<User>}
     */
    #users = [];

    /**
     * @type {number}
     */
    #index = 0;

    /**
     * @type {number}
     */
    #distance = 0;

    /**
     * @type {number}
     */
    #beforeThreshold = 0;

    /**
     * @type {number}
     */
    #afterThreshold = 5;

    static selectors = {
      AMBASSADOR_CONTENT: ".vga-intro-ambassador__content",
      AMBASSADOR_LIST: ".vga-intro-ambassador__list",
      AMBASSADOR_PREV: ".vga-intro-ambassador__button[data-action='prev']",
      AMBASSADOR_NEXT: ".vga-intro-ambassador__button[data-action='next']",
      VIDEO_CONTENT: ".vga-intro-video__content",
    };

    static classes = {
      AMBASSADOR_LIST: "vga-intro-ambassador__list",
      AMBASSADOR_ITEM: "vga-intro-ambassador__item",
      AMBASSADOR_AVATAR: "vga-intro-ambassador__avatar",
      AMBASSADOR_NAME: "vga-intro-ambassador__name",
      VIDEO: "vga-intro-video__video",
      ACTIVE: "is--active",
    };

    /**
     * @constructor
     * @param {Array<User>} users
     */
    constructor(users) {
      this.#users = users;

      this.$content = _.$(VGAIntro.selectors.AMBASSADOR_CONTENT);
      this.$prev = _.$(VGAIntro.selectors.AMBASSADOR_PREV);
      this.$next = _.$(VGAIntro.selectors.AMBASSADOR_NEXT);
      this.$videoWrapper = _.$(VGAIntro.selectors.VIDEO_CONTENT);

      this.#createAmbassador();
      this.#createVideo();

      this.#initActiveItemAndVideo();
      this.#bindEvents();
    }

    #createAmbassador() {
      const list = _.createElement("ul", {
        class: VGAIntro.classes.AMBASSADOR_LIST,
      });

      this.#users.forEach((user, i) => {
        const avatar = _.createElement(
          "div",
          {
            class: ["vograce-flex-0", "vograce-avatar", VGAIntro.classes.AMBASSADOR_AVATAR].join(" "),
          },
          `<img class="vograce-avatar__inner" src="${user.avatarUrl}" alt="${user.name}" />`
        );

        const name = _.createElement(
          "div",
          {
            class: ["vograce-typography", VGAIntro.classes.AMBASSADOR_NAME].join(" "),
          },
          `<span>${user.name}</span>`
        );

        const item = _.createElement(
          "li",
          {
            class: [VGAIntro.classes.AMBASSADOR_ITEM, i === 0 ? VGAIntro.classes.ACTIVE : ""].join(" "),
            data: {
              index: i,
            },
          },
          [avatar, name]
        );

        list.appendChild(item);
      });

      this.$content.appendChild(list);
    }

    #createVideo() {
      const snippets = [];

      this.#users.forEach((user, i) => {
        const src = user.videoUrl;
        const isActive = i === 0;

        const classes = [VGAIntro.classes.VIDEO, isActive ? VGAIntro.classes.ACTIVE : ""].join(" ");

        const attributes = [isActive ? "autoplay" : "", "muted", "loop", "controls", "playsinline"].join(" ");

        snippets.push(`
          <video id="VGA-INTRO-VIDEO-${i}" class="${classes}" src="${src}" ${attributes}></video>
        `);
      });

      this.$videoWrapper.innerHTML = snippets.join("");
    }

    #initActiveItemAndVideo() {
      const selector = `.${VGAIntro.classes.AMBASSADOR_ITEM}.${VGAIntro.classes.ACTIVE}`;
      const target = _.$(selector);
      if (!target) return;

      this.#index = +_.dataset(target, "index");
      this.$activeItem = target;
      this.$activeVideo = _.$(`#VGA-INTRO-VIDEO-${this.#index}`);
      this.$list = _.$(VGAIntro.selectors.AMBASSADOR_LIST);
    }

    #bindEvents() {
      _.on(this.$content, "click", this.#clickItem.bind(this));

      if (_.isMobile()) return;
      _.on(this.$prev, "click", this.#clickPrev.bind(this));
      _.on(this.$next, "click", this.#clickNext.bind(this));
    }

    #clickItem(e) {
      const selector = `.${VGAIntro.classes.AMBASSADOR_ITEM}`;
      const target = e.target.closest(selector);
      if (!target) return;

      const index = +_.dataset(target, "index");
      if (index === this.#index) return;

      this.#toggle(index);
    }

    #clickPrev() {
      if (this.#index === 0) return;

      this.#toggle(this.#index - 1);
    }

    #clickNext() {
      if (this.#index === this.#users.length - 1) return;

      this.#toggle(this.#index + 1);
    }

    #toggle(index) {
      // 暂停当前播放的视频
      if (this.$activeVideo) {
        this.$activeVideo.pause();
      }

      _.removeClass(this.$activeItem, VGAIntro.classes.ACTIVE);
      _.removeClass(this.$activeVideo, VGAIntro.classes.ACTIVE);

      const selector = `.${VGAIntro.classes.AMBASSADOR_ITEM}[data-index="${index}"]`;
      const item = _.$(selector);
      const video = _.$(`#VGA-INTRO-VIDEO-${index}`);

      _.addClass(item, VGAIntro.classes.ACTIVE);
      _.addClass(video, VGAIntro.classes.ACTIVE);

      // 播放新选中的视频
      if (video) {
        video.play().catch(() => {
          // 如果自动播放失败（某些浏览器策略限制），静默处理
        });
      }

      this.#index = index;
      this.$activeItem = item;
      this.$activeVideo = video;

      if (index < this.#beforeThreshold) {
        this.#beforeThreshold = index;
        this.#afterThreshold = this.#afterThreshold - 1;
        this.#distance -= 122;
        this.#scroll();
      } else if (index > this.#afterThreshold) {
        this.#afterThreshold = index;
        this.#beforeThreshold = this.#beforeThreshold + 1;
        this.#distance += 122;
        this.#scroll();
      }
    }

    #scroll() {
      _.css(this.$list, {
        transform: `translate3d(-${this.#distance}px, 0, 0)`,
      });
    }
  }

  class VGARecommended {
    #resetIndex = 0;

    #currentIndex = 0;

    #loopStartIndex = 0;

    #itemWidth = 0;

    #timer = null;

    static selectors = {
      ROOT: ".vga-recommended",
      LIST: ".vga-recommended__list",
      ITEM: ".vga-recommended__item",
      LEFT_CONTROL: "[data-slider-action='prev']",
      RIGHT_CONTROL: "[data-slider-action='next']",
    };

    constructor() {
      if (_.isMobile()) return;

      this.$root = _.$(VGARecommended.selectors.ROOT);
      this.$list = _.$(VGARecommended.selectors.LIST, this.$root);
      this.$leftCtrl = _.$(VGARecommended.selectors.LEFT_CONTROL, this.$root);
      this.$rightCtrl = _.$(VGARecommended.selectors.RIGHT_CONTROL, this.$root);

      this.#init();
    }

    async #init() {
      this.#bindEvents();
      this.#cloneItems();
      await _.wait(10000);
      this.#startRolling();
    }

    #bindEvents() {
      _.on(this.$leftCtrl, "click", this.#prev.bind(this));
      _.on(this.$rightCtrl, "click", this.#next.bind(this));
    }

    #prev() {
      if (this.#currentIndex === 0) return;

      clearInterval(this.#timer);
      this.#currentIndex--;
      this.#scroll(true);
      this.#startRolling();
    }

    #next() {
      clearInterval(this.#timer);
      this.#currentIndex++;
      this.#scroll(true);
      this.#startRolling();
    }

    #cloneItems() {
      const fragment = document.createDocumentFragment();
      const fragment2 = document.createDocumentFragment();
      const items = _.$$(VGARecommended.selectors.ITEM, this.$root);

      items.forEach((item) => {
        const clonedItem = item.cloneNode(true);
        const clonedItem2 = item.cloneNode(true);
        fragment.appendChild(clonedItem);
        fragment2.appendChild(clonedItem2);
      });

      this.#itemWidth = _.getRect(items.item(0)).width;
      this.#loopStartIndex = items.length - 1;
      this.#resetIndex = items.length * 2;
      this.$list.appendChild(fragment);
      this.$list.appendChild(fragment2);
    }

    #startRolling() {
      this.#timer = setInterval(() => {
        this.#currentIndex++;
        this.#scroll(true);

        if (this.#currentIndex === this.#resetIndex) {
          this.#currentIndex = this.#loopStartIndex;
          this.#scroll(false);
        }
      }, 5000);
    }

    #scroll(animate = true) {
      const distance = this.#currentIndex * (this.#itemWidth + this.#getGap());

      _.css(this.$list, {
        transform: `translate3d(-${distance}px, 0, 0)`,
        transition: animate ? "transform 0.3s ease-in-out" : "none",
      });
    }

    #getGap() {
      return _.isMobile() ? 16 : 24;
    }
  }

  function syncHeadingBackgrounds() {
    document.querySelectorAll(".vog-section--content").forEach((content) => {
      let prev = content.previousElementSibling;
      if (prev.classList.contains("vog-section--heading")) {
        const bgColor = getComputedStyle(content).backgroundColor;
        prev.style.backgroundColor = bgColor;
      }
    });
  }

  _.ready(() => {
    if (window.template !== "page.ambassador") return;

    // 同步 Heading 的背景色
    syncHeadingBackgrounds();

    const users = fetchUsersData();
    new VGARegion(users);
    new VGAIntro(users.filter((user) => !!user.videoUrl));
    // new VGARecommended();
  });
});
